import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const InqueryAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.inqueryAccess
        ? setValues((j) => ({
            ...j,
            inquery: {
              create: true,
              edit: true,
              delete: true,
              status: true,
              followUp: true,
              followUpCUD: true,
              export: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            inquery: {
              create: false,
              edit: false,
              delete: false,
              status: false,
              followUp: false,
              followUpCUD: false,
              export: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.inqueryAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      inquery: { ...j.inquery, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.inqueryAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.inquery?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.inquery?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.inquery?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Status"
          checked={values.inquery?.status || false}
          name={"status"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Export"
          checked={values.inquery?.export || false}
          name={"export"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Follow Up"
          checked={values.inquery?.followUp || false}
          name={"followUp"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Follow Up Create, Update and Delete"
          checked={values.inquery?.followUpCUD || false}
          name={"followUpCUD"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default InqueryAccess;
